export default "__VITE_ASSET__28ad787b__"